import type { Options } from 'integrations/hooks/useFetch';

const urlWithEventHubParams = (url: string, options: Options): string =>
  `${url}?eventHubName=${options.eventHubName}&connectionString=${options.connectionString}&consumerGroup=${options.consumerGroup}`;

export default urlWithEventHubParams;
